import { render, staticRenderFns } from "./mainScreen.vue?vue&type=template&id=7b418408&"
import script from "./mainScreen.vue?vue&type=script&lang=js&"
export * from "./mainScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports